import { HStack, Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { IconSnsFacebook, IconSnsInstagram, IconSnsTwitter } from '../icons'
import { TextBodyBold2 } from '../common/Text'
import Link from '../common/Link'
import SVG from '../common/SVG'

export type FooterSNSProps = BoxProps & {}

const FooterSNS: React.FC<FooterSNSProps> = ({ ...others }) => {
  return (
    <>
      <Box {...others}>
        <Box mb="20px">
          <TextBodyBold2 localizeKey="nav__title__sns" />
        </Box>
        <HStack spacing="20px">
          <Link to="https://twitter.com/SenseIsland">
            <SVG svg={<IconSnsTwitter />} w="30px" />
          </Link>
          <Link to="https://www.facebook.com/Sense-Island-109572490384999/">
            <SVG svg={<IconSnsFacebook />} w="24px" />
          </Link>
          <Link to="https://www.instagram.com/senseisland_sarushima/">
            <SVG svg={<IconSnsInstagram />} w="24px" />
          </Link>
        </HStack>
      </Box>
    </>
  )
}

export default FooterSNS
